import { types } from 'mobx-state-tree';

export const MerchantConfiguration = types.model('MerchantConfiguration', {
	price_currency: types.string
});
